import { FunctionComponent } from 'react'
import Modal from 'components/shared/Modal'
import { URL_DOCUMENT_AUTOMATION } from 'constants/links'

interface Props {
  client?: string
}

// Placeholder copy pending final wording from commercial
const Main: FunctionComponent<Props> = ({ client }) => (
  <Modal
    open
    onClose={() => {}}
    disableClose
    title='Access denied'
    size='medium'
    actions={
      <a
        href={URL_DOCUMENT_AUTOMATION}
        target='_blank'
        rel='noopener noreferrer'
        className='pointer bg-suez-canal br3 ph6 pv4 white f5 bn hover-o-90 no-underline'
      >
        Contact us
      </a>
    }
  >
    <p className='mt0'>
      {client !== undefined && client !== ''
        ? `You don't currently have access to FromCounsel data via ${client}. `
        : 'Something went wrong. '}
      To find out about your subscription options, please click{' '}
      <a target='_blank' rel='noopener noreferrer' href={URL_DOCUMENT_AUTOMATION}>here</a> and a
      member of our team will be in touch.
    </p>
  </Modal>
)

export default Main
